import React from 'react';
import { Link } from 'react-router-dom';
import footerImage from '../assets/images/Image_fx (74).jpg';
import footerMaiaImage from '../assets/images/Image_fx (64).jpg';

const Footer = () => {
  return (
    <footer data-wf--footer-main--variant="base" className="footer_wrap">
      <div className="footer_top_wrap u-grid-tablet">
        <div id="w-node-_4d70e769-70ce-28d0-f7cb-d70dd9b5305c-d9b5305a" className="footer_top_image">
          <div data-image-reveal="" className="footer_top_file">
            <div data-image-cover="" className="g_image_cover"></div>
            {footerImage && (
              <img
                src={footerImage}
                loading="lazy"
                data-image=""
                alt="Side frontal facade of a modern, luxury residential home"
                className="footer_top_asset"
              />
            )}
          </div>
        </div>
        <div id="w-node-_4d70e769-70ce-28d0-f7cb-d70dd9b53061-d9b5305a" className="footer_navigation_wrap">
          <ul id="" className="footer_navigation_contain">
            <li className="footer_navigation_li">
              <Link data-link-hover="" to="/" className="g_footer_text w-inline-block">
                <div className="g_footer_contain">
                  <div data-link="black" className="g_footer_text u-text-h3">Home</div>
                </div>
              </Link>
            </li>
            <li className="footer_navigation_li">
              <Link data-link-hover="" to="/works" className="g_footer_text w-inline-block">
                <div className="g_footer_contain">
                  <div data-link="black" className="g_footer_text u-text-h3">Works</div>
                </div>
              </Link>
            </li>
            <li className="footer_navigation_li">
              <Link data-link-hover="" to="/studio" className="g_footer_text w-inline-block">
                <div className="g_footer_contain">
                  <div data-link="black" className="g_footer_text u-text-h3">About</div>
                </div>
              </Link>
            </li>
            <li className="footer_navigation_li">
              <Link data-link-hover="" to="/process" className="g_footer_text w-inline-block">
                <div className="g_footer_contain">
                  <div data-link="black" className="g_footer_text u-text-h3">Process</div>
                </div>
              </Link>
            </li>                      
          </ul>
        </div>
        <div id="w-node-_4d70e769-70ce-28d0-f7cb-d70dd9b5306f-d9b5305a" className="footer_details_wrap">
          <div className="footer_info_wrap">
            <div data-wf--global-eyebrow--variant="base" className="g_eyebrow u-text-small">info</div>
            <div className="footer_info_contain">
              <div className="footer_info_text"><span className="footer_info_span">A:</span> 경기도 부천시 원미구 부일로 330번길 10-1 F</div>
              <div className="footer_info_text"><span className="text-span">E:</span> info@faire323.pro</div>
              <div className="footer_info_text"><span className="text-span-2">P:</span> 032 221 4896</div>
              <div className="footer_info_text"><span className="text-span-3">H:</span> 010 3881 4896</div>
            </div>
            {footerMaiaImage && (
              <img
                src={footerMaiaImage}
                loading="lazy"
                width="156"
                height="66"
                alt="A black and white Member Australian Institute of Architects badge"
                className="footer_info_maia"
              />
            )}

          </div>
        </div>
      </div>
      <div className="footer_bottom_wrap u-grid-tablet u-text-small">
        <div id="w-node-_4d70e769-70ce-28d0-f7cb-d70dd9b5308b-d9b5305a" className="footer_bottom_copyright">
          <div className="footer_bottom_text"><span data-current-year="" className="footer_bottom_year">2025</span> FAIRE 323</div>
        </div>
        <div id="w-node-_4d70e769-70ce-28d0-f7cb-d70dd9b53090-d9b5305a" className="footer_bottom_legals">
          <div className="footer_bottom_list">
            <Link data-link-hover="" to="/privacy-policy" className="g_link u-text-small w-inline-block">
              <div className="g_link_contain">
                <div data-link="black" className="g_link_text black-2">Privacy Policy</div>
              </div>
            </Link>
          </div>
          <div className="footer_bottom_list">
            <Link data-link-hover="" to="/terms-of-service" className="g_link u-text-small w-inline-block">
              <div className="g_link_contain">
                <div data-link="black" className="g_link_text black-2">Terms of Service</div>
              </div>
            </Link>
          </div>
        </div>
        <div id="w-node-_4d70e769-70ce-28d0-f7cb-d70dd9b53095-d9b5305a" className="footer_bottom_links">
          <div className="footer_bottom_credits"></div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;